import React, { useEffect, useState } from 'react'
import '../assets/css/singleRecipe.css'
import '../assets/css/procedure.css'
import '../assets/css/style.css'
import RecipesBig from '../components/RecipesBig'
import LatestRecipes from '../components/LatestRecipes'
import Categories from '../components/Categories'
import Header2 from '../components/Header2'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Procedure from '../components/Procedure'
import RecipesShort from '../components/RecipesShort'
import Greeting from '../components/Greeting'

import imageChef from '../assets/images/chef2.jpg'
import { useParams } from 'react-router-dom'


export default function SingleRecipe() {
    const [recipeBig, setRecipeBig] = useState([]);
    const [latestRecipe, setLatestRecipe] = useState([]);
    const [recipeShort, setRecipeShort] = useState([]);
    const [ingredientsRecipe, setIngredientsRecipe] = useState([]);
    const [directionsRecipe, setDirectionsRecipe] = useState([]);
    const [recipeNutrition, setRecipeNutrition] = useState([]);

    const { id } = useParams();

    useEffect(() => {
      fetch(`https://lazy-chef-api.vercel.app/recipe/${id}`, {
            credentials: 'include'
        })
        .then((response) => response.json())
        .then((data) => {
            const recipeBig1 = data.recipeResponse;
            const latest1 = data.latestRecipes;
            const recipeShort1 = data.recipeShorts;
            const ingredients1 = data.ingredientsList;
            const directions1 = data.directionsRecipes;
            const nutrition1 = data.recipeNutrition;
            setRecipeBig(recipeBig1);
            setLatestRecipe(latest1);
            setRecipeShort(recipeShort1);
            setIngredientsRecipe(ingredients1);
            setDirectionsRecipe(directions1);
            setRecipeNutrition(nutrition1);
        })
        .catch((error) => {
          console.log(error)
        });
    }, [id]);
  

    const params = useParams();

  return (
    <div className='RecipeBody'>
    <Navbar active='recipes'/>
    <div className='recipeMainContainer container'>
        <div className='row pt-5'>
            <div className='col-xl-7'>
                <div className='recipeHeading'>{recipeBig[0]?.title}</div>
                <div className='recipeDescriptionContainer'>
                    <RecipesBig data={recipeBig}/>

                    <Procedure recipeIngredients={ingredientsRecipe} recipeDirections={directionsRecipe} recipeNutrition={recipeNutrition}/>
                    <div className='row' style={{paddingBottom: '2rem'}}>
                        <div className='col-3 tryAlso'>Try this also</div>
                        <div className='col-7' style={{paddingTop: '1rem'}}><hr/></div>
                    </div>
                    <div className='row inSingleRecipe'>
                        <RecipesShort  data={recipeShort}/>
                    </div>
                </div>
            </div>
            <div className='col-xl-5 pt-5 ps-5 latestRecipes'>
                <LatestRecipes data={latestRecipe}/>
                <div className='givingPadding'>
                    <Categories/>
                </div>
                <div className='SingleRecipeHeader'>
                    <Header2/>
                </div>
            </div>
        </div>
    </div>
    <div className='SingleRecipeGreet'>
        <Greeting image={imageChef} start={'Delight Your Senses with '} mid={'Culinary'} end={' Creations'} cat=''/>
    </div>
    <Footer/>
    </div>
  )
}
